import './Navbar.css';
import logo from '../../assets/logo.png';

const Navbar = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '5531972035157';
    const message = 'Olá, gostaria de fazer um orçamento de paineis de LED para meu evento.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <nav>
      <div className="nav-container">
        <img src={logo} alt="ACJ Locações" className="logo" />
        <div className="nav-links">
          <a href="#hero-info">Sobre nós</a>
          <a href="#service-types">Serviços</a>
          <a href="#contato">Contato</a>
          <button className="button-primary" onClick={handleWhatsAppClick}>
            Faça um orçamento
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 
